<template>
  <v-sheet class="document-list">
    <base-list
      :userType="userType"
      :listItems="documents"
      :showAdd="false"
      :showDelete="showDelete"
      :link="setLink"
      :linksAsDownloads="true"
    />
    <document-upload v-if="showDelete" />
  </v-sheet>
</template>

<script>
import titleMixin from "@/mixins/titleMixin"
import DocumentUpload from "@/containers/documents/DocumentUpload"
import { DocumentsAPI } from "@/lib/api"
import EventBus from "@/lib/eventBus"
import eventMixin from "@/mixins/eventMixin"
import BaseList from "@/components/BaseList"
import User from "@/lib/user"

export default {
  mixins: [eventMixin, titleMixin],
  components: {
    DocumentUpload,
    BaseList
  },
  data: function() {
    return {
      title: "Documents",
      documents: [],
      userType: User.getUserType(),
      showDelete: !User.isMember()
    }
  },
  methods: {
    getDocuments: function() {
      DocumentsAPI.list().then(response => {
        this.documents = response
      })
    },
    setLink(el) {
      return el.url
    }
  },
  created() {
    EventBus.$on("DocumentAdded", () => {
      this.getDocuments()
    })

    this.addListener("list:removeItem", itemId => {
      DocumentsAPI.delete(itemId).then(() => {
        this.getDocuments()
      })
    })
    this.getDocuments()
  }
}
</script>

<style lang="css" scoped>
.document-list {
  max-width: 800px;
}
</style>
